import React from "react";
import Eye from "@Components/Icons/Eye";
import EyeClose from "@Components/Icons/EyeClose";
import InfoCircle from "@Components/Icons/InfoCircle";
import { roundToFormat } from "@Shared/Helpers/Numbers";
import RenderTooltip from "@Components/HoverTooltip/RenderTooltip";
import styles from "./index.module.scss";
export default class FormInput extends React.Component {
    static defaultProps = {
        value: "",
        type: "text",
        error: false,
        name: "",
        valueChanged: () => { },
        title: "",
        left: false,
        customErrorMessage: "",
    };
    constructor(props) {
        super(props);
        this.state = {
            passwordShown: this.props.showPassword,
            value: "",
        };
        this.tooltipRef = React.createRef();
    }
    tooltipRef;
    componentDidMount() {
        if (this.props.type === "currency" ||
            this.props.type === "currencyNew" ||
            this.props.type === "gb" ||
            this.props.type === "gbNew" ||
            this.props.type === "number" ||
            this.props.type === "numberNew" ||
            this.props.type === "data" ||
            this.props.type === "percentage" ||
            this.props.type === "linesNew") {
            this.updateStateToDisplayValue();
        }
    }
    componentDidUpdate(previousProps) {
        if ((this.props.type === "currency" ||
            this.props.type === "currencyNew" ||
            this.props.type === "gb" ||
            this.props.type === "gbNew" ||
            this.props.type === "number" ||
            this.props.type === "numberNew" ||
            this.props.type === "data" ||
            this.props.type === "percentage" ||
            this.props.type === "linesNew") &&
            this.props.value !== previousProps.value) {
            this.updateStateToDisplayValue();
        }
    }
    updateStateToDisplayValue = () => {
        const value = this.getValue(this.props.value);
        this.setState({
            value,
        });
    };
    changeInput = (event) => {
        const value = event.target.value;
        if (this.props.type === "currency" ||
            this.props.type === "currencyNew" ||
            this.props.type === "gb" ||
            this.props.type === "gbNew" ||
            this.props.type === "number" ||
            this.props.type === "numberNew" ||
            this.props.type === "data" ||
            this.props.type === "percentage" ||
            this.props.type === "linesNew") {
            this.setState({
                value,
            });
            return;
        }
        return this.update(value);
    };
    processValue = (value_) => {
        if (this.getType() !== "number") {
            return value_;
        }
        let value = value_;
        if (typeof value_ === "string") {
            value = value_.replaceAll(/[^\d.]/g, "");
        }
        if (value.endsWith(".")) {
            return value;
        }
        const numberValue = Number(value);
        if (Number.isNaN(numberValue)) {
            return value_;
        }
        if (numberValue < 0 && !this.props.negative) {
            return 0;
        }
        if (this.props.noDecimal) {
            return Math.floor(numberValue);
        }
        return value;
    };
    update = (value) => {
        if (this.props.valueChanged) {
            this.props.valueChanged(this.props.name, value);
        }
    };
    passwordToggle = () => {
        this.setState((previousState) => ({
            passwordShown: !previousState.passwordShown,
        }));
    };
    handleBlur = () => {
        let displayValue = this.getValue(this.processValue(this.state.value));
        let realValue = Number.parseFloat(displayValue.replaceAll(",", ""));
        if (Number.isNaN(realValue)) {
            realValue = undefined;
            displayValue = "";
        }
        this.setState({
            value: displayValue,
        });
        this.update(realValue);
    };
    handleErrors = () => {
        if (this.props.error && this.props.setErrors !== undefined) {
            this.props.setErrors({});
        }
    };
    getValue = (value) => {
        if (value === "") {
            return "";
        }
        if (String(value).startsWith(".")) {
            //add 0 before decimal point
            value = `0${value}`;
        }
        if (String(value).endsWith(".")) {
            //add 0 after decimal point
            value = `${value}0`;
        }
        if (typeof value === "string") {
            value = Number(value);
        }
        if (this.props.noDecimal) {
            return roundToFormat(value, 0);
        }
        return roundToFormat(value, 2);
    };
    getType = () => {
        if (this.props.type === "currency" ||
            this.props.type === "currencyNew" ||
            this.props.type === "data" ||
            this.props.type === "percentage" ||
            this.props.type === "lines" ||
            this.props.type === "linesNew" ||
            this.props.type === "gb" ||
            this.props.type === "gbNew" ||
            this.props.type === "number" ||
            this.props.type === "numberNew") {
            return "number";
        }
        if (this.props.type === "fakeCurrency") {
            return "text";
        }
        if (this.props.type === "textNew") {
            return "text";
        }
        if (this.props.type === "passwordNew") {
            if (this.state.passwordShown) {
                return "text";
            }
            return "password";
        }
        if (this.props.type === "emailNew") {
            return "email";
        }
        if (this.state.passwordShown) {
            return "text";
        }
        return this.props.type;
    };
    incrementCount = () => {
        let { value } = this.props;
        if (value === undefined || value === "") {
            value = 0;
        }
        if (typeof value === "string") {
            value = Number(value);
        }
        this.update(value + 1);
    };
    decrementCount = () => {
        let { value } = this.props;
        if (value === undefined || value === "") {
            value = 0;
        }
        if (typeof value === "string") {
            value = Number(value);
        }
        this.update(value - 1);
    };
    hideZero = () => {
        if (this.getType() === "number" &&
            (this.props.value === 0 || this.props.value === "0")) {
            this.setState({
                value: "",
            });
        }
    };
    handleValidityOnInput = () => {
        // clear the message when re-typing
        this.props.clearErrorMessage(this.props.name);
    };
    render() {
        const error = this.props.error ? styles.error : "";
        const currency = this.props.type === "currency" && !this.props.plusMinus
            ? styles.currency
            : "";
        const fakeCurrency = this.props.type === "fakeCurrency" ? styles.fakeCurrency : "";
        const percentage = this.props.type === "percentage" ? styles.percentage : "";
        const number = this.props.type === "number" ? styles.number : "";
        const plusMinus = this.props.plusMinus ? styles.plusMinus : "";
        const lines = this.props.type === "lines" ? styles.lines : "";
        const gb = this.props.type === "gb" ? styles.gb : "";
        const data = this.props.type === "data" ? styles.data : "";
        const isNewDesign = [
            "textNew",
            "passwordNew",
            "linesNew",
            "currencyNew",
            "gbNew",
            "numberNew",
            "emailNew",
        ].includes(this.props.type);
        const newDesign = isNewDesign ? styles.newDesign : "";
        const linesNew = this.props.type === "linesNew" ? styles.lines : "";
        const currencyNew = this.props.type === "currencyNew" ? styles.currency : "";
        const gbNew = this.props.type === "gbNew" ? styles.gb : "";
        const numberNew = this.props.type === "numberNew" ? styles.number : "";
        const classes = [
            styles.wrapper,
            error,
            currency,
            currencyNew,
            fakeCurrency,
            percentage,
            data,
            plusMinus,
            lines,
            linesNew,
            gb,
            gbNew,
            numberNew,
            newDesign,
        ].join(` `);
        const type = this.getType();
        const small = this.props.small === true ? styles.small : "";
        const blue = this.props.blue === true ? styles.blue : "";
        const disabled = this.props.disabled === true ? styles.disabled : "";
        const left = this.props.left === true ? styles.left : "";
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.inputContainer },
                React.createElement("div", { className: `${classes} ${this.props.className}`, ref: this.tooltipRef, "data-title": this.props.type === "numberNew"
                        ? this.props.title
                        : undefined },
                    this.props.title.length > 0 &&
                        this.props.type !== "numberNew" ? (React.createElement("div", { className: `${styles.title} ${small}` }, this.props.title)) : (React.createElement(React.Fragment, null)),
                    this.props.plusMinus && (React.createElement("div", { className: styles.minus, onClick: this.decrementCount },
                        React.createElement("div", { className: styles.minusText }, "-"))),
                    React.createElement("input", { className: `${styles.input} ${small} ${newDesign} ${plusMinus} ${currency} ${currencyNew} ${fakeCurrency} ${lines} ${linesNew} ${gb} ${gbNew} ${numberNew} ${percentage} ${number} ${left} ${data} ${disabled} ${blue}`, name: this.props.name, type: type === "number" ? "text" : type, onChange: this.changeInput, value: this.props.type === "currency" ||
                            this.props.type === "currencyNew" ||
                            this.props.type === "gb" ||
                            this.props.type === "gbNew" ||
                            this.props.type === "number" ||
                            this.props.type === "numberNew" ||
                            this.props.type === "data" ||
                            this.props.type === "percentage" ||
                            this.props.type === "linesNew"
                            ? this.state.value
                            : this.props.value, disabled: this.props.disabled, maxLength: this.props.maxlength, placeholder: this.props.placeholder, step: type === "number" ? 0.01 : "", autoComplete: "off", onBlur: this.props.type === "currency" ||
                            this.props.type === "currencyNew" ||
                            this.props.type === "gb" ||
                            this.props.type === "gbNew" ||
                            this.props.type === "number" ||
                            this.props.type === "numberNew" ||
                            this.props.type === "data" ||
                            this.props.type === "percentage" ||
                            this.props.type === "linesNew"
                            ? this.handleBlur
                            : () => { }, onFocus: () => {
                            this.handleErrors();
                            this.hideZero();
                            this.handleValidityOnInput();
                        }, onInput: this.handleValidityOnInput }),
                    this.props.plusMinus && (React.createElement("div", { className: styles.plus, onClick: this.incrementCount },
                        React.createElement("div", null, "+"))),
                    this.props.type === "password" && (React.createElement(Eye, { className: styles.icon, primary: this.state.passwordShown, onClick: () => this.passwordToggle() })),
                    this.props.type === "passwordNew" &&
                        (this.state.passwordShown ? (React.createElement(Eye, { className: styles.icon, primary: this.state.passwordShown, onClick: () => this.passwordToggle() })) : (React.createElement(EyeClose, { className: styles.icon, onClick: () => this.passwordToggle() }))),
                    ["textNew", "emailNew"].includes(this.props.type) &&
                        this.props.error && (React.createElement(InfoCircle, { className: `${styles.icon} ${styles.iconError}` })),
                    !isNewDesign && this.props.customErrorMessage !== "" && (React.createElement(RenderTooltip, { reference: this.tooltipRef, addLeftPx: 120 }, this.props.customErrorMessage))),
                isNewDesign && !!this.props.customErrorMessage && (React.createElement("div", { className: styles.errorMessage }, this.props.customErrorMessage)))));
    }
}
